import React, { useState, useEffect } from 'react';
import PopupHeader from '../../pages/common-page/popupHeader';
import { Button, Card, CardContent } from '@material-ui/core';
import { useFormik } from 'formik';
import { FormGroup, ButtonWrapperFilter, useStyles } from '../../styles/common-styles'
import DefaultTable from '../../utils/Table/DefaultTable';
import { TextInput, SelectGroupInput, SelectInput } from '../Forms';
import { getApi, postApi } from '../../services/apiBase';
import { student_lookup, student_dropdown, student_lookup_billing_batch } from '../../services/apiURL';
import { useSelector, useDispatch } from "react-redux";
import { searchDataSelector } from '../../redux/common/search-data/selectors';
import { getStudentLookup } from '../../redux/common/search-data/action';
import { batchSelector } from '../../redux/billing/batch/selectors';
import { ssnSymbolic } from '../../helper/currencyCodes';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { search_student_lookup } from '../../services/navigation_folder/admissions';
import GenericModal from '../../components/Modal/GenericModal';
import { formatSSN, formatSSNVisibility, formSSNNumber } from '../../helper/formatSSN';

const SearchStudent = ({ onLookupClose, setStudent, hideBreadcrumb = false, isBillingBatchDistribute = false }) => {
    const { t } = useTranslation(['translation', 'tableHeadCells', 'registration']);
    const [alertPopup, setAlertPopup] = useState(false);
    const [selectedRowValue, setSelectedRow] = useState('');
    

     const headCells = [
        { id: 'studentUID', numeric: true, disablePadding: false, label: t('students.studentUid', { ns: 'tableHeadCells' }) },
        { id: 'studentID', numeric: true, disablePadding: false, label: t('students.studentId', { ns: 'tableHeadCells' }) },
        { id: 'studentName', numeric: true, disablePadding: false, label: t('students.studentName', { ns: 'tableHeadCells' }) },
        { id: 'applicantStatus', numeric: true, disablePadding: false, label: t('students.applicantStatus', { ns: 'tableHeadCells' }) },
        { id: 'campus', numeric: true, disablePadding: false, label: t('students.campus', { ns: 'tableHeadCells' }) },
        { id: 'maidenName', numeric: true, disablePadding: false, label: t('students.maidenName', { ns: 'tableHeadCells' }) },
        { id: 'suffix', numeric: true, disablePadding: false, label: t('students.suffix', { ns: 'tableHeadCells' }) },
        { id: 'businessHold', numeric: true, disablePadding: false, label: t('students.businessHold', { ns: 'tableHeadCells' }) }
    ];
    const classess = useStyles();
    //Getting contact details
    const { allData } = useSelector(searchDataSelector);
    const {batch} = useSelector(batchSelector);
    const [tableRow, setTableRow] = useState([])
    const dispatch = useDispatch();
    const [isLoading, setIsloading] = useState(false);
    const [prevScreenURL, setPrevScreenURL] = useState('');
   

    useEffect(() => {
        setTableRow(allData.studentLookup);
    }, [allData.studentLookup])

    const [Dropdown, setDropdown] = useState({
        "cohortRefs": [],
        "studentTypes": [],
        "addressType": [],
        "campuses": []
    })

    const [defaultValueCampus, setDefaultValueCampus] = useState(0)
    const [ssnPattern, setSsnPattern] = useState('');
    const [ssnVisibility, setSsnVisibility] = useState("None");
    const [currencyCode, setCurrencyCode] = useState('');
    let superUser = localStorage.getItem('superUser')
    let campusID = localStorage.getItem('campusID')
        
    //API Call for dropdown
    useEffect(() => {
        getApi(student_dropdown).then((resp) => {
            const { cohortRefs, studentTypes, addressType, campuses, ssnVisibility, ssnPictureTypeID } = resp.data.data
             setSsnVisibility(ssnVisibility);
            setCurrencyCode (ssnPictureTypeID);
            const pattern = ssnSymbolic[ssnPictureTypeID]['pattern'];
             setSsnPattern(pattern);
            setDropdown({
                ...Dropdown,
                cohortRefs: cohortRefs,
                 studentTypes: studentTypes,
                addressType: addressType,
                campuses: campuses
            })
        }).catch((err) => {
            console.log(err);
        })
        return () => {
            dispatch(getStudentLookup([]))
        }
    }, [])

    const formatToSSN = (value, pattern) => {
                return (ssnVisibility && (ssnVisibility.toLowerCase() === 'full')) ? formatSSNVisibility(value, ssnPattern) : value
            }

     const onBlurSSN = (e) => {
        const { name, value } = e.target;
        const formattedSSN = formatToSSN(value, ssnPattern);
        formik.setFieldValue(name, formattedSSN);
    }

    //Getting Prospect Id
    const history = useHistory();
    useEffect(() => {
        if (history.location) {
            setPrevScreenURL(history.location.pathname);
        }
        if (history.location.state) {
            const { studentUID } = history.location.state.selectedRow
            formik.setFieldValue('studentUId', studentUID);
        }
    }, [])
    const formik = useFormik({
        initialValues: {
            "studentId": "",
            "lastName": "",
            "firstName": "",
            "maidenName": "",
            "nationalId": "",
            "expCohortId": 0,
            "studentUId": 0
        },
        onSubmit: (values) => {
            const payloadRequest = {
                ...values
            }
            
            switch (prevScreenURL) {
                case '/billing/batch':
                    {
                        if (isBillingBatchDistribute) {
                            payloadRequest["batchMasterID"] = batch.selectedBatch.batchMasterID;
                        }
                        
                        setIsloading(true);
                        postApi(`${student_lookup_billing_batch}`, payloadRequest).then((resp) => {
                            const { isSuccess, data } = resp.data
                            if (isSuccess) {
                                setIsloading(false);
                                dispatch(getStudentLookup(data))
                            }
                        }).catch((err) => {
                            console.log(err)
                        })
                    }
                    break;
                default:
                    {
                        setIsloading(true);
                        postApi(`${student_lookup}`, payloadRequest).then((resp) => {
                            const { isSuccess, data } = resp.data
                            if (isSuccess) {
                                setIsloading(false);
                                dispatch(getStudentLookup(data))
                            }
                        }).catch((err) => {
                            console.log(err)
                        })
                    }
                    break;
            }
           
           
        }
    });

   
    const onBack = (value) => {
        onLookupClose(value)

    }
    const handleRowSelect = (value) => {
         setSelectedRow(value)

        if (value.businessHold >0) {
            setAlertPopup(true)
            
        }
        else {
            onBack(false)
            value && setStudent(value)
        }
       
    }
    const onButton = (value) => {
        onBack(false)
        selectedRowValue && setStudent(selectedRowValue)
    }
    React.useEffect(() => {
        document.getElementsByTagName('html')[0].classList.add('popup-Page');
        setAlertPopup(false);
    }, [])
    return (
        <>
            {(alertPopup) && <GenericModal
                title={t('commonLabel.studenthasBusinesshold')}
                open={alertPopup}
                onClose={setAlertPopup}
                buttonText={t('buttonLabel.ok')}
                onButtonPress={onButton}

            />}
            <PopupHeader title={t('transferLabel.searchStudent', { ns: 'registration' })} navigationList={search_student_lookup} onClose={onBack} hideBreadcrumb={hideBreadcrumb} />
            <form onSubmit={formik.handleSubmit} autoComplete="off" className={classess.root}>
                <Card>
                    <CardContent>
                        <FormGroup >
                             <SelectInput
                                labelId='studentTypeId'
                                label={t('studentLabel.studentType')}
                                formikValue={formik.values.studentTypeId}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: Dropdown.studentTypes }} />
                            <TextInput label={t('studentLabel.studentId')} labelId={'studentId'} formikValue={formik.values.studentId} formikChange={formik.handleChange} />
                            <TextInput label={t('studentLabel.studentSSN')} labelId='studentSSN' formikValue={formik.values.studentSSN} formikChange={formik.handleChange} disabled={(ssnVisibility.toUpperCase() === "FULL" ? false: true)} ssnSymbolicPattern={ssnSymbolic && ssnSymbolic[currencyCode] && ssnSymbolic[currencyCode]['pattern']} maxLength={11} onBlur={onBlurSSN} errors={formik.errors.studentSSN} touched={formik.touched.studentSSN} />
                            <TextInput label={t('commonLabel.nationalId')} maxlength={'10'} labelId={"nationalId"} formikValue={formik.values.nationalId} formikChange={formik.handleChange} />

                        </FormGroup>
                        <FormGroup>
                            <TextInput label={t('commonLabel.lastName')} maxlength={'60'} labelId={"lastName"} formikValue={formik.values.lastName} formikChange={formik.handleChange} />
                            <TextInput label={t('commonLabel.firstName')} maxlength={'60'} labelId={"firstName"} formikValue={formik.values.firstName} formikChange={formik.handleChange} />
                            <TextInput label={t('commonLabel.maidenName')} maxlength={'60'} labelId={"maidenName"} formikValue={formik.values.maidenName} formikChange={formik.handleChange} />
                            <TextInput label='Preferred Name' labelId='preferredName' formikValue={formik.values.preferredName} formikChange={formik.handleChange} />
                        </FormGroup>
                        <FormGroup>
                            <SelectInput
                                labelId='addressTypeId'
                                label={t('commonLabel.addressType')}
                                formikValue={formik.values.addressTypeId}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: Dropdown.addressType }} />
                            <TextInput maxlength={'60'} label={t('commonLabel.city')} labelId='city' formikValue={formik.values.city} formikChange={formik.handleChange} />
                            <TextInput maxlength={'50'} label={t('commonLabel.state')} labelId='state' formikValue={formik.values.state} formikChange={formik.handleChange} />
                            <TextInput maxlength={'10'} label={t('commonLabel.zipCode')} labelId='zipcode' formikValue={formik.values.zipcode} formikChange={formik.handleChange} />
                        </FormGroup>
                        <FormGroup>
                            <TextInput
                                label={t('commonLabel.email')}
                                labelId="email"
                                formikValue={formik.values.email}
                                formikChange={formik.handleChange}
                                errors={formik.errors.email}
                                touched={formik.touched.email}
                                maxlength={'50'}
                            />
                            <SelectGroupInput label={t('commonLabel.cohort')} labelId={'expCohortId'} formikValue={formik.values.expCohortId} formikChange={formik.handleChange} dropdownData={{ optionLists: Dropdown.cohortRefs, key: 'displayText', value: 'uniqueId', groupLabel: 'activeFlag', groupOne: 'Active', groupTwo: 'Inactive' }} />
                            <SelectInput
                                disabled={(superUser === 'N') ? true : false}
                                labelId='campusId'
                                label={t('commonLabel.campus')}
                                formikValue={formik.values.campusId}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: Dropdown.campuses }} />
                            
                        </FormGroup>
                        <ButtonWrapperFilter>
                            <Button className='BgYellowOrange search' variant="contained" size="large" type="submit" >
                                {t('buttonLabel.search')}
                            </Button>
                            <Button className="BgLightBlue search" variant="contained" size="large" type="reset" onClick={e => { formik.resetForm(); dispatch(getStudentLookup([])) }}>
                                {t('buttonLabel.reset')}
                            </Button>
                            <Button className="BgLightBlue search" variant="contained" size="large" onClick={() => onBack('')}>
                                {t('buttonLabel.cancel')}
                            </Button>
                        </ButtonWrapperFilter>
                    </CardContent>
                </Card>
            </form>
            <DefaultTable trackingLabel={"searchStudent"} headCells={headCells} rows={tableRow} pagination={true} isLookup={true} onRowSelect={handleRowSelect} isLoading={isLoading} />
        </>
    )
}

export default SearchStudent;